/**
 * API to interact with StackMap
 */

import fetchJsonp from 'fetch-jsonp';
import { from } from 'rxjs';

/**
 * Fetch map data from StackMap
 * @param {string} domain
 * @param {object} data
 * @param {string} data.library - Branch name
 * @param {string} data.location - Collection
 * @param {string} data.callno - Call Numbers
 * @returns {Observable}
 */
function fetchMap(domain, data) {
  const queryString = new URLSearchParams(data).toString();
  const url = `https://${domain}.stackmap.com/json/?${queryString}&callback=`;

  return from(
    fetchJsonp(url, { timeout: 10000 })
      .then(response => response.json())
      .then(responseData => ({ body: responseData }))
  );
}

export default {
  fetchMap
};
